import "../../styles/About.css";
import Headshot from "../../images/headshot.jpeg";

const About = () => {
  return (
    <section id="about" className="about">
      <div className="about-intro">
        <h2>About me</h2>
        <div className="underline">
          <div className="heading-underline"></div>
          <div className="heading-underline-end"></div>
        </div>
      </div>
      <div className="about-container">
        <figure>
          <img src={Headshot} alt="Jarrod Gilliland Headshot" />
        </figure>
        <div className="about-summary">
          <div className="about-summary-intro">
            <h3>So, who am I?</h3>
            <p>
              I'm your next{" "}
              <span style={{ color: "#1a9a92", fontWeight: "500" }}>
                Front End Developer
              </span>
              , of course!
            </p>
          </div>
          <div className="about-description">
            <p>
              I am a self-taught Front End Developer from Columbus, Ohio. My
              learning journey started four years ago building a simple static
              webpage with FreeCodeCamp. Once I realized how much I enjoyed
              coding, I decided to learn more through Udemy where I earned
              several certificates for JavaScript, React, Advanced CSS and Sass,
              Node.js, and web accessibility with WCAG 2.1+.
            </p>
            <p>
              Most of my time is spent building projects and experimenting with
              new features, learning a new language and implementing it into
              projects, and spending time on StackOverflow looking for
              solutions.
            </p>
            <p>
              When I'm not sifting through documentation you'll find me
              hiking/running my favorite trails and parks around Ohio, reading
              an exciting thriller novel, hanging out with my cat, Craig, or
              just taking it easy playing some of my favorite video games.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
